import { render, staticRenderFns } from "./PackList.vue?vue&type=template&id=056779a0&"
import script from "./PackList.vue?vue&type=script&lang=js&"
export * from "./PackList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports